import { apiClient } from './client';
import type { User, ApiResponse } from '@/types';

export interface LoginCredentials {
  email: string;
  password: string;
}

export interface LoginResponse {
  user: User;
  token: string;
}

export async function login(credentials: LoginCredentials): Promise<ApiResponse<LoginResponse>> {
  const response = await apiClient.post<ApiResponse<LoginResponse>>('/admin/login', credentials);
  return response.data;
}

export async function getProfile(): Promise<ApiResponse<User>> {
  const response = await apiClient.get<ApiResponse<User>>('/admin/profile');
  return response.data;
}

export async function verifyToken(): Promise<ApiResponse<{ valid: boolean }>> {
  const response = await apiClient.get<ApiResponse<{ valid: boolean }>>('/admin/verify');
  return response.data;
}
